import { useEffect, useState } from 'react'
import {
  boundedHeicOutput,
  HeicConverterPage,
  type HeicOutputFormat,
} from '@/features/heic-converter'
import { useT } from '@/shared/i18n'

export function HeicToJpgPage() {
  const t = useT()
  const [output, setOutput] = useState<HeicOutputFormat>('jpg')

  useEffect(() => {
    setOutput(
      boundedHeicOutput(new URLSearchParams(window.location.search).get('output')),
    )
  }, [])

  return (
    <HeicConverterPage
      key={output}
      copy={t.heicToJpg}
      initialOutput={output}
    />
  )
}
